import styled from 'styled-components'
import { space, color, typography, display } from 'styled-system'
import propTypes, { createPropTypes } from '@styled-system/prop-types'
import { theme, mq } from 'config/theme'
import { Box } from 'components/atoms/Layout'

const textFunctions = [display, space, color, typography]

const styledPropTypes = {
  ...createPropTypes(display.propNames),
  ...propTypes.space,
  ...propTypes.color,
  ...propTypes.typography,
}

export const Text = styled.p`
  font-size: ${theme.fontSizes.m};
  color: ${theme.colors.text};
  ${textFunctions}
`

Text.propTypes = styledPropTypes

const Block = styled(Box)`
  > * + * {
    margin-top: ${({ gutter }) => theme.space[gutter] || gutter};
  }
`

Block.defaultProps = {
  gutter: '1em',
}

Text.Block = Block

export const H1 = styled.h1`
  font-size: ${theme.fontSizes.h2};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.h1};
  `}
  color: ${theme.colors.heading};
  ${textFunctions}
`

export const H2 = styled.h2`
  font-size: ${theme.fontSizes.h3};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.h2};
  `}
  color: ${theme.colors.heading};
  ${textFunctions}
`

export const H3 = styled.h3`
  font-size: ${theme.fontSizes.xxl};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.h3};
  `}
  color: ${theme.colors.heading};
  ${textFunctions}
`

export const H4 = styled.h4`
  font-size: ${theme.fontSizes.xl};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.xxl};
  `}
  color: ${theme.colors.heading};
  ${textFunctions}
`

export const H5 = styled.h5`
  font-size: ${theme.fontSizes.l};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.xl};
  `}
  color: ${theme.colors.heading};
  ${textFunctions}
`

export const H6 = styled.h6`
  font-size: ${theme.fontSizes.m};
  ${mq.from.tablet`
    font-size: ${theme.fontSizes.l};
  `}
  color: ${theme.colors.heading};
  ${textFunctions}
`
